import React from "react";
import { FaRegClock } from "react-icons/fa";
import styles from "./WillBeAvailableLater.module.css";
import Footer from "../../components/Shared/Footer";

const WillBeAvailableLater = () => {
  return (
    <div>
      <div className={styles.WillBeAvailableLater}>
        <div className={styles.content}>
          <FaRegClock className={styles.icon} />
          <h1>Will be available later</h1>
          <p>We're working on this page. Please check back later.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default WillBeAvailableLater;
